import React from "react";
import { Typography, Box, Card, CardContent } from "@mui/material";
import { useTranslation } from "react-i18next";

export const Home = () => {
  const { t } = useTranslation();

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h4" gutterBottom>
        RestMenu QR Web
      </Typography>
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Добро пожаловать!
          </Typography>
          <Typography variant="body1">
            Веб-версия приложения для QR-меню ресторана.
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            Phase 2: Core Logic Migration - Завершена ✅
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};
